import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from '../create-request-saga'
import { addSettings } from 'portal-modules/common/redux/modules/settings'
import createFormAction from 'portal-modules/common/redux/create-form-action'

// action types
export const REQUEST_PROPERTY_CONTACTS =
  'rp/contact_property/REQUEST_PROPERTY_CONTACTS'
export const RECEIVE_PROPERTY_CONTACTS =
  'rp/contact_property/RECEIVE_PROPERTY_CONTACTS'
const SEND_NEW_MESSAGE_GROUP = 'rp/messages/SEND_NEW_MESSAGE_GROUP'
// action creators
export const requestPropertyContacts = () => ({
  type: REQUEST_PROPERTY_CONTACTS,
})

export const receivePropertyContacts = payload => ({
  type: RECEIVE_PROPERTY_CONTACTS,
  payload,
})

export const sendMessage = createFormAction(SEND_NEW_MESSAGE_GROUP)

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_PROPERTY_CONTACTS:
      return { ...state, ...payload }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

function* fetchPropertyContacts() {
  const { info, settings } = yield call(Api.getContactInfoWithSettings)

  if (info) {
    yield put({
      type: RECEIVE_PROPERTY_CONTACTS,
      payload: info,
    })
  }

  if (settings) {
    yield put(addSettings({ propertyContacts: settings }))
  }
}

export function* watchRequestPropertyContacts() {
  yield takeLatest(
    REQUEST_PROPERTY_CONTACTS,
    createRequestSaga(fetchPropertyContacts, {
      key: 'propertyContacts',
      message: __('Checking for property contacts'),
    }),
  )
}

function* postNewMessage({ payload }) {
  yield call(Api.postMessage, payload)
}

function* watchSendMessage() {
  yield takeLatest(
    SEND_NEW_MESSAGE_GROUP,
    createRequestSaga(postNewMessage, {
      key: 'sendMessages',
      message: __('Sending your message'),
      successMessage: __('Message successfully sent'),
      write: true,
    }),
  )
}

export const sagas = [watchRequestPropertyContacts, watchSendMessage]
